import axios from "axios";
import {removeUserSession} from "../Utils/Security";
import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";

function Logout({ setAuthenticated }) {
    const history = useHistory();

    const handleLogout = (event) => {
        event.preventDefault();
        axios.post("/api/logout", {}).then(resp => {
            removeUserSession();
            setAuthenticated(false);
            history.push('/login');
        });
    }

    return (
        <div>
            <a href="" onClick={handleLogout}>Logout</a>
        </div>
    );
}

export default Logout;

Logout.propTypes = {
    setAuthenticated: PropTypes.func.isRequired
}